import React, { useState } from "react";
import { Bar } from "react-chartjs-2";

export const ReportBarChart = ({ data }) => {
  const [schoolData] = useState({
    labels: data.map((school) => school.school_name),
    datasets: [
      {
        label: "Usage in Hours",
        data: data.map((school) => Math.ceil(school.total_usage / 60)),
      },
    ],
  });

  return (
    <div className="report-bar-chart-container">
      {schoolData && (
        <Bar
          data={schoolData}
          options={{
            indexAxis: "y",
            plugins: {
              legend: {
                display: false,
              },
              title: {
                display: true,
                text: "Top 20 Schools with High Usage in this month",
                font: {
                  size: 20,
                },
              },
            },
            scales: {
              y: {
                beginAtZero: true,
              },
            },
          }}
        />
      )}
    </div>
  );
};
